import {ActivatedRoute} from '@angular/router';
import {Component, ViewEncapsulation} from '@angular/core';
import {AuthService} from 'app/user/auth.service';

@Component({
    selector: 'app-root-styler',
    template: '',
    styleUrls: ['app-root-styler.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppRootStylerComponent {
    constructor(private _authService: AuthService) {
        this._authService.isAuth.subscribe(isAuth => {
            if (isAuth) {
                document.body.classList.remove('not-authenticated');
            } else {
                document.body.classList.add('not-authenticated');
            }
        });
    }
}